import React from 'react';
import {
  Button, Modal, Tabs, TimePicker, Select, message, Radio, Input,
} from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { Text, Box, Flex } from '../../../shared/components';
import Caja from '../../assets/img/Caja.png';
import { setVisible } from '../../../../state/actions/creators/caja.actioncreator';
import { guardarGastos } from '../../../../state/actions/creators/caja.creador.actioncreators';

const { TabPane } = Tabs;
function handleChange(value) {
  //console.log(`selected ${value}`);
}

class CajaModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      okButton: 'Iniciar',
      cancelButton: 'Forzar inicio',
      aditionalButton: true,
      inicioCaja: false,
      guardarGasto: false,
      cantidadInicio: '',
      cantidadGastos: '',
      cantidadMovimiento: '',
    };
  }

  showMessage(text) {
    switch (text) {
      case 'Iniciar': {
        message.success('Inicio de caja correcto');
        break;
      }
      case 'Guardar gasto': {
        message.success('Gasto guardado con exito');
        break;
      }
      case 'Guardar movimiento': {
        message.success('Movimiento guardado con exito');
        break;
      }
    }
  }

  callback(context, key) {
    switch (key) {
      case '1': {
        context.setState({
          okButton: 'Iniciar',
          cancelButton: 'Forzar Inicio',
          aditionalButton: true,
        });
        break;
      }
      case '2': {
        context.setState({
          okButton: 'Guardar gasto',
          cancelButton: 'Cancelar',
          aditionalButton: false,
        });
        break;
      }
      case '3': {
        context.setState({
          okButton: 'Guardar movimiento',
          cancelButton: 'Cancelar',
          aditionalButton: false,
        });
        break;
      }
      case '4': {
        context.setState({
          okButton: 'Cerrar caja',
          cancelButton: 'Cancelar',
          aditionalButton: false,
        });
        break;
      }
    }
  }

  render() {
    const handleInputNumber = (valor, key) => {
      const isItFloat = str => /[0-9]/.test(str);
      const value = valor;
      if (!isItFloat(valor)) {
        switch (key) {
          case 'Inicio':
            this.setState({ cantidadInicio: '' });
            break;
          case 'Gastos':
            this.setState({ cantidadGastos: '' });
            break;
          case 'Movimientos':
            this.setState({ cantidadMovimiento: '' });
            break;
        }
      } else {
        switch (key) {
          case 'Inicio':
            this.setState({ cantidadInicio: valor.replace(',', '.') });
            break;
          case 'Gastos':
            this.setState({ cantidadGastos: valor.replace(',', '.') });
            break;
          case 'Movimientos':
            this.setState({ cantidadMovimiento: valor.replace(',', '.') });
            break;
        }
      }
    };
    const {
      setVisible, isOpen, guardarGastos, formasPago, user,
    } = this.props;
    return (

      <Modal
        style={{ marginTop: '16px' }}
        bodyStyle={{ paddingBottom: 20 }}
        width={366}
        height={290}
        title={(
          <Box>
            <Flex>
              <Text fontWeight="600px" fontSize="18px" width="144px" marginLeft="-8px">Gestión de Caja </Text>
              {' '}
              <Box style={{
                height: '24px',
                width: '58px',
                border: '1px solid #B7EB8F',
                borderRadius: '4px',
                backgroundColor: '#F6FFED',
                boxSizing: 'border-box',
                lineHeight: '18px',
              }}
              >
                <Text fontSize="12px" color="#00AC70" style={{ marginLeft: '7px' }}> Abierta </Text>
              </Box>
            </Flex>
            <Text fontSize="14px" color="#777572" marginLeft="-8px" mt="8px">
              Triana. Caja nº
              {user && user.user_info ? user.user_info.caja : ''}
              - Fecha:
              {moment().format('DD-MM-YYYY')}
            </Text>
          </Box>
)}
        visible={isOpen}
        onCancel={() => setVisible(true, 'SET_VISIBLE')}
        okText={this.state.okButton}
        cancelText={this.state.cancelButton}
        footer={[
          this.state.aditionalButton
            ? (
              <Button key="back" style={{ marginRight: '33px', height: '40px', width: '99px' }} onClick={() => setVisible(true, 'SET_VISIBLE')}>
                Cancelar
              </Button>
            ) : (
              <Button key="show" hidden onClick={() => setVisible(true, 'SET_VISIBLE')}>
                Cancelar
              </Button>
            ),,
          <Button key="cancel" style={{ height: 40 }} onClick={() => setVisible(true, 'SET_VISIBLE')}>
            {this.state.cancelButton}
          </Button>,
          <Button
            key="submit"
            style={{
              marginTop: '8px', marginBottom: '8px', marginRight: '2px', height: '40px',
            }}
            type="primary"
            width="30"
            onClick={() => guardarGastos(), () => this.showMessage(this.state.okButton)
        }
          >
            {this.state.okButton}
          </Button>,

        ]}
      >
        <Tabs style={{ marginLeft: '-24px', marginRight: '-24px', marginTop: '-24px' }} defaultActiveKey="1" centered value="small" fontSize="16" onChange={key => this.callback(this, key)}>
          <TabPane tab="Inicio" key="1">
            <Flex>
              <Text style={{ marginLeft: '16px' }} fontSize="16">Hora</Text>
              <Text style={{ marginLeft: '138px' }} fontSize="16">Cantidad</Text>
            </Flex>
            <Flex mt="8px">
              <TimePicker style={{ marginLeft: '16px', width: '159px' }} defaultValue={moment()} size="large" />
              <Input style={{ marginLeft: '16px', width: '159px' }} value={this.state.cantidadInicio} onChange={({ target: { value } }) => handleInputNumber(value, 'Inicio')} suffix={<Text color="#BFBFBF">€</Text>} />
            </Flex>
          </TabPane>

          <TabPane tab="Gastos" key="2">
            <Flex>
              <Text style={{ marginLeft: '16px' }} fontSize="16">Hora</Text>
              <Text style={{ marginLeft: '138px' }} fontSize="16">Cantidad</Text>
            </Flex>

            <Flex mt="8px" style={{ marginLeft: '16px' }}>
              <TimePicker style={{ width: '159px' }} defaultValue={moment()} size="large" />
              <Input style={{ marginLeft: '16px', width: '159px' }} value={this.state.cantidadGastos} onChange={({ target: { value } }) => handleInputNumber(value, 'Gastos')} suffix={<Text color="#BFBFBF">€</Text>} />
            </Flex>

            <Text style={{ marginLeft: '16px' }} mt="16px" fontSize="16">Forma de pago</Text>
            <Select defaultValue="" size="large" style={{ width: '334px', marginLeft: '16px', marginTop: '8px' }} onChange={handleChange}>
              {formasPago.map(formaPago => (
                <Select.Option key={formaPago.id} value={formaPago.id}>
                  {formaPago.descripcion}
                </Select.Option>
              ))}
            </Select>

            <Text style={{ marginLeft: '16px' }} fontSize="16" mt="16px">Concepto</Text>
            <TextArea style={{ width: '334px', marginLeft: '16px', marginTop: '8px' }} />
          </TabPane>
          <TabPane tab="Movimientos" key="3">

            <Flex style={{ marginLeft: '16px' }}>
              <Radio.Group style={{ textAlign: 'center', marginBottom: '8px' }} mt="8px" defaultValue="entrada">
                <Radio.Button style={{ width: '167px', height: '40px', marginBottom: '8px' }} value="entrada"><Text mt="3px">Entrada</Text></Radio.Button>
                <Radio.Button style={{ width: '167px', height: '40px' }} value="salida"><Text mt="3px">Salida</Text></Radio.Button>
              </Radio.Group>
            </Flex>

            <Flex>
              <Text style={{ marginLeft: '16px' }} fontSize="16">Hora</Text>
              <Text style={{ marginLeft: '138px' }} fontSize="16">Cantidad</Text>
            </Flex>

            <Flex mt="8px" style={{ marginLeft: '16px' }}>
              <TimePicker style={{ width: '159px' }} defaultValue={moment()} size="large" />
              <Input style={{ marginLeft: '16px', width: '159px' }} value={this.state.cantidadMovimiento} onChange={({ target: { value } }) => handleInputNumber(value, 'Movimientos')} suffix={<Text color="#BFBFBF">€</Text>} />
            </Flex>

            <Text style={{ marginLeft: '16px' }} fontSize="16" mt="16px">Forma de pago</Text>
            <Select defaultValue="" size="large" style={{ width: '334px', marginLeft: '16px', marginTop: '8px' }} onChange={handleChange}>
              {formasPago.map(formaPago => (
                <Select.Option key={formaPago.id} value={formaPago.id}>
                  {formaPago.descripcion}
                </Select.Option>
              ))}
            </Select>

            <Text style={{ marginLeft: '16px' }} fontSize="16" mt="16px">Concepto</Text>
            <TextArea style={{ width: '334px', marginLeft: '16px', marginTop: '8px' }} />
          </TabPane>

          <TabPane tab="Cierre" key="4">
            <img
              style={{
                marginLeft: '100px', marginTop: '25px', width: '170px', height: '151px', marginBottom: '13px',
              }}
              src={Caja}
            />
            <Text
              width="279px"
              marginRight="44.5px"
              marginLeft="42.5px"
              marginBottom="30px"
              style={{ lineHeight: '25.6px', textAlign: 'center' }}
            >
              {' '}
              Para cerrar caja
              {' '}
              <br />
              {' '}
              primero hay que
              {' '}
              <Text style={{ color: '#049BDD' }}> hacer arqueo caja </Text>
            </Text>
          </TabPane>
        </Tabs>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => {
  const { core, auth } = state;
  const { formasPago } = core;
  const { user } = auth;
  const {
    handleCajaModal: {
      isOpen,
    },
  } = state;
  return { isOpen, formasPago, user };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setVisible,
    guardarGastos,

  }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(CajaModal);
